"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withUseModalHOC = void 0;
const react_1 = __importDefault(require("react"));
const use_modal_1 = require("./use-modal");
const withUseModalHOC = (WrappedComponent) => {
    const FunctionalComponent = (props) => {
        const modalFunctions = (0, use_modal_1.useModal)();
        return react_1.default.createElement(WrappedComponent, { ...props, ...modalFunctions });
    };
    FunctionalComponent.displayName = 'UseModalHOC';
    return FunctionalComponent;
};
exports.withUseModalHOC = withUseModalHOC;
